import {observer} from "mobx-react-lite";
import * as React from "react";
import {WhoisIPData} from "../../models/ioc";
import {Col, Row, Table} from "react-bootstrap";

const WhoisIPResults = observer(function WhoisIPResults(props: { data: WhoisIPData }) {
    const {data} = props

    return <Table bordered striped>
        <tbody>
        <tr>
            <td>Query:</td>
            <td>{data.query}</td>
        </tr>
        <tr>
            <td>ASN registry:</td>
            <td>{data.asn_registry}</td>
        </tr>
        <tr>
            <td>ASN:</td>
            <td>{data.asn}</td>
        </tr>
        <tr>
            <td>ASN CIDR:</td>
            <td>{data.asn_cidr}</td>
        </tr>
        <tr>
            <td>ASN Country:</td>
            <td>{data.asn_country_code}</td>
        </tr>
        <tr>
            <td>ASN Date:</td>
            <td>{data.asn_date}</td>
        </tr>
        <tr>
            <td colSpan={2}>
                <Row>
                    <Col>Handle</Col>
                    {data.nets.map(v => <Col>{v.handle}</Col>)}
                </Row>
                <Row>
                    <Col>Description</Col>
                    {data.nets.map(v => <Col>{v.description}</Col>)}
                </Row>
                <Row>
                    <Col>CIDR</Col>
                    {data.nets.map(v => <Col>{v.cidr}</Col>)}
                </Row>
                <Row>
                    <Col>Range</Col>
                    {data.nets.map(v => <Col>{v.range}</Col>)}
                </Row>
                <Row>
                    <Col>Created</Col>
                    {data.nets.map(v => <Col>{v.created}</Col>)}
                </Row>
                <Row>
                    <Col>Updated</Col>
                    {data.nets.map(v => <Col>{v.updated}</Col>)}
                </Row>
                <Row>
                    <Col>Email(s)</Col>
                    {data.nets.map(v => <Col>{v.emails}</Col>)}
                </Row>
                <Row>
                    <Col>Address</Col>
                    {data.nets.map(v => <Col>{v.address}</Col>)}
                </Row>
                <Row>
                    <Col>City</Col>
                    {data.nets.map(v => <Col>{v.city}</Col>)}
                </Row>
                <Row>
                    <Col>State</Col>
                    {data.nets.map(v => <Col>{v.state}</Col>)}
                </Row>
                <Row>
                    <Col>Postal Code</Col>
                    {data.nets.map(v => <Col>{v.postal_code}</Col>)}
                </Row>
                <Row>
                    <Col>Country</Col>
                    {data.nets.map(v => <Col>{v.country}</Col>)}
                </Row>
            </td>
        </tr>
        </tbody>
    </Table>
})

export default WhoisIPResults